"use client";

import React, { createContext, useContext, useState, ReactNode } from 'react';

interface MultiSessionContextType {
  currentRole: string | null;
  createNewRole: (role: string) => Promise<string | null>;
}

const MultiSessionContext = createContext<MultiSessionContextType | undefined>(undefined);

export function MultiSessionProvider({ children }: { children: ReactNode }) {
  const [currentRole, setCurrentRole] = useState<string | null>(null);

  const createNewRole = async (role: string) => {
    setCurrentRole(role);
    return `mock-session-${role}`;
  };

  return (
    <MultiSessionContext.Provider value={{ currentRole, createNewRole }}>
      {children}
    </MultiSessionContext.Provider>
  );
}

export function useMultiSessionContext() {
  const context = useContext(MultiSessionContext);
  if (context === undefined) {
    // Return mock for build stability if not wrapped
    return {
        currentRole: null,
        createNewRole: async (role: string) => null
    };
  }
  return context;
}
